import {
  Card,
  CardContent,
  CardHeader,
  IconButton,
  LabelValueList,
  PencilAltIcon,
  Typography,
  useModal,
  useRouter,
} from '@forgeglobal/design-framework'
import { IssuerMarketplaceModal } from 'components/issuers/IssuerMarketplaceModal'
import { IssuerPartnershipsModal } from 'components/issuers/IssuerPartnershipsModal'
import { OwnerChip } from 'components/shared/chips/OwnerChip'
import { useIssuerOwnersQuery } from 'graphql/bindings/AdminBindings'
import React, { Fragment } from 'react'
import RightAlign from 'components/shared/RightAlign'
import capitalize from 'lodash/capitalize'

export const IssuerMarketplaceCoverage: React.FC = () => {
  const { match } = useRouter<{ id: string }>()
  const issuerId = match.params.id
  const { data } = useIssuerOwnersQuery({ variables: { issuerId: issuerId } })
  const account = data?.account
  const owners = account?.owners ?? []
  const marketplaceOwners = owners.filter(owner => owner.owner_group === 'marketplace')
  const [firstOwner, ...otherOwners] = marketplaceOwners
  const notes = account?.marketplace_notes ?? ''
  const [showModal, hideModal] = useModal(() => {
    return <IssuerMarketplaceModal hideModal={hideModal} issuerId={issuerId} />
  }, [issuerId])

  return (
    <Card>
      <CardHeader
        title="Marketplace Coverage"
        action={
          <IconButton onClick={showModal}>
            <PencilAltIcon />
          </IconButton>
        }
      />
      <CardContent>
        <LabelValueList
          items={[
            {
              label: 'Marketplace Owner',
              value: <OwnerChip owner={firstOwner} />,
              isEmpty: !firstOwner,
            },
            {
              label: 'Additional Forge Contact(s)',
              value: (
                <RightAlign>
                  {otherOwners.map(owner => (
                    <OwnerChip owner={owner} key={owner.id} />
                  ))}
                </RightAlign>
              ),
              isEmpty: !otherOwners.length,
            },
            {
              label: 'Relationships strength',
              value: capitalize(account?.relationship_strength ?? ''),
              isEmpty: !account?.relationship_strength,
            },
            {
              label: 'Relationship sensitivity',
              value: (
                <Fragment>
                  <Typography variant="body1" align="right">
                    {capitalize(account?.relationship_sensitivity ?? '')}
                  </Typography>
                  <Typography variant="body1" align="right">
                    {account?.relationship_notes}
                  </Typography>
                </Fragment>
              ),
              isEmpty: !account?.relationship_sensitivity,
            },
            {
              label: 'Additional information',
              value: notes,
              isEmpty: !notes,
              fullWidth: !!notes,
            },
          ]}
        />
      </CardContent>
    </Card>
  )
}
export const IssuerPartnershipsCoverage: React.FC = () => {
  const { match } = useRouter<{ id: string }>()
  const issuerId = match.params.id
  const { data } = useIssuerOwnersQuery({ variables: { issuerId: issuerId } })
  const account = data?.account
  const owners = account?.owners ?? []
  const partnershipsOwners = owners.filter(owner => owner.owner_group === 'partnerships')
  const [firstOwner, ...otherOwners] = partnershipsOwners
  const notes = account?.partnerships_notes ?? ''
  const [showModal, hideModal] = useModal(() => {
    return <IssuerPartnershipsModal hideModal={hideModal} issuerId={issuerId} />
  }, [issuerId])
  return (
    <Card>
      <CardHeader
        title="Partnerships Coverage"
        action={
          <IconButton onClick={showModal}>
            <PencilAltIcon />
          </IconButton>
        }
      />
      <CardContent>
        <LabelValueList
          items={[
            {
              label: 'Partnerships Owner',
              value: <OwnerChip owner={firstOwner} />,
              isEmpty: !firstOwner,
            },
            {
              label: 'Additional Forge Contact(s)',
              value: (
                <RightAlign>
                  {otherOwners.map(owner => (
                    <OwnerChip owner={owner} key={owner.id} />
                  ))}
                </RightAlign>
              ),
              isEmpty: !otherOwners.length,
            },
            {
              label: 'Relationships strength',
              value: capitalize(account?.partnerships_relationship_strength ?? ''),
              isEmpty: !account?.partnerships_relationship_strength,
            },
            {
              label: 'Relationship sensitivity',
              value: (
                <Fragment>
                  <Typography variant="body1" align="right">
                    {capitalize(account?.partnerships_relationship_sensitivity ?? '')}
                  </Typography>
                  <Typography variant="body1" align="right">
                    {account?.partnerships_relationship_notes}
                  </Typography>
                </Fragment>
              ),
              isEmpty: !account?.partnerships_relationship_sensitivity ?? '',
            },
            {
              label: 'Additional information',
              value: notes,
              isEmpty: !notes,
              fullWidth: !!notes,
            },
          ]}
        />
      </CardContent>
    </Card>
  )
}
